import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const MatchSnap = () => {
  const [target, setTarget] = useState(100);
  const [values, setValues] = useState([]);
  const [flippedCards, setFlippedCards] = useState([]);
  const [matchedIndices, setMatchedIndices] = useState([]);
  const [matchedCount, setMatchedCount] = useState(0);
  const [status, setStatus] = useState('');
  const matchSound = new Audio("https://cdn.pixabay.com/download/audio/2022/03/15/audio_dab93e2d6e.mp3?filename=success-1-6297.mp3");

  useEffect(() => {
    startGame();
  }, [target]);

  const generatePairs = (target) => {
    const baseNums = [12, 25, 35, 42, 49, 55, 65, 72, 88, 15, 30, 70, 28, 85, 10, 90,5,4];
    const possible = baseNums.filter(n => baseNums.includes(target - n));
    const pairs = [];
    for (let i = 0; i < 8; i++) {
      const n = possible[Math.floor(Math.random() * possible.length)];
      pairs.push(n, target - n);
    }
    return shuffle(pairs);
  };

  const shuffle = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const startGame = () => {
    const newValues = generatePairs(target);
    setValues(newValues);
    setFlippedCards([]);
    setMatchedIndices([]);
    setMatchedCount(0);
    setStatus(`🎯 Find pairs that add up to ${target}!`);
  };

  const handleCardClick = (index) => {
    if (flippedCards.length >= 2 || flippedCards.includes(index) || matchedIndices.includes(index)) return;

    const newFlipped = [...flippedCards, index];
    setFlippedCards(newFlipped);

    if (newFlipped.length === 2) {
      const firstVal = values[newFlipped[0]];
      const secondVal = values[newFlipped[1]];
      const sum = firstVal + secondVal;

      if (sum === target) {
        matchSound.play();
        setStatus('✅ Matched!');
        setMatchedCount(prev => prev + 2);
        setMatchedIndices(prev => [...prev, ...newFlipped]);
        setTimeout(() => {
          setFlippedCards([]);
          if (matchedCount + 2 === values.length) {
            setStatus('🎉 All pairs matched! Fantastic!');
            const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
          }
        }, 600);
      } else {
        setStatus('❌ Not a match!');
        setTimeout(() => {
          setFlippedCards([]);
          setStatus(`Try again! Match to ${target}`);
        }, 1000);
      }
    }
  };

  const getCardStyle = (isFlipped) => ({
    width: '100%',
    aspectRatio: '1',
    backgroundColor: isFlipped ? '#fff' : '#aed581',
    color: isFlipped ? '#33691e' : 'white',
    fontSize: '1.8rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    border: isFlipped ? '2px solid #33691e' : 'none',
    cursor: 'pointer',
    // transform: isFlipped ? 'rotateY(180deg)' : 'none',
    transform: isFlipped ? 'scale(1.05)' : 'scale(1)',

    transition: 'transform 0.3s',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  });

  return (
    <div style={{
      fontFamily: "'Comic Sans MS', cursive",
      background: '#f0f4c3',
      textAlign: 'center',
      padding: '30px',
      minHeight: '100vh'
    }}>
      <h2 style={{ color: '#33691e' }}>🌟 Match & Snap! - Custom Target Practice</h2>

      <div style={{ marginBottom: '20px' }}>
        <label htmlFor="customTarget">🎯 Enter Target Number:</label>
        <input
          type="number"
          id="customTarget"
          value={target}
          onChange={(e) => setTarget(parseInt(e.target.value) || 100)}
          style={{
            marginLeft: '10px',
            padding: '10px',
            backgroundColor: '#dcedc8',
            color: '#33691e',
            borderRadius: '8px',
            border: 'none',
            fontSize: '1rem'
          }}
        />
      </div>

      <div style={{
        fontSize: '1.2rem',
        marginBottom: '20px',
        minHeight: '30px'
      }}>{status}</div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
        gap: '15px',
        justifyContent: 'center',
        maxWidth: '500px',
        margin: '0 auto'
      }}>
        {values.map((value, idx) => {
          const isFlipped = flippedCards.includes(idx) || matchedIndices.includes(idx);
          return (
            <div
              key={idx}
              style={getCardStyle(isFlipped)}
              onClick={() => handleCardClick(idx)}
            >
              {isFlipped ? value : ''}
            </div>
          );
        })}
      </div>

      <button onClick={startGame} style={{
        marginTop: '30px',
        padding: '10px 20px',
        backgroundColor: '#689f38',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        cursor: 'pointer'
      }}>🔁 Restart  Game</button>
    </div>
  );
};

export default MatchSnap;
